import { ApolloLink, Observable } from '@apollo/client';
import Raven from 'raven-js';
import devLogger from 'react-utils/devLogger';
const getOperationDetails = operation => {
  const {
    operationName,
    variables
  } = operation;
  const context = operation.getContext();
  const correlationId = context.correlationId;
  const isMutation = operation.query.definitions && operation.query.definitions.some(definition => definition.kind === 'OperationDefinition' && definition.operation === 'mutation');
  return {
    operationName,
    isMutation,
    correlationId,
    // only include variables if query is not a mutation.
    // Mutations can contain PII/GDPR-sensitive data
    variables: isMutation ? 'mutation' : JSON.stringify(variables)
  };
};
export const errorMonitoringLink = new ApolloLink((operation, forward) => new Observable(observer => {
  const sub = forward(operation).subscribe({
    next(result) {
      observer.next(result);
      if (!result.errors || !result.errors.length) {
        return;
      }
      for (const err of result.errors) {
        const message = `customer-data-sidebar-apollo-client: ${err.message}`;
        Raven.captureException(new Error(message), {
          extra: getOperationDetails(operation)
        });
        devLogger.warn({
          message,
          key: message
        });
      }
    },
    error(err) {
      const operationDetails = getOperationDetails(operation);
      if (err.errorCode === 'TIMEOUT') {
        const message = 'customer-data-sidebar-apollo-client: graphQLTimeout';
        Raven.captureException(new Error(message), {
          extra: Object.assign({
            errorCode: err.errorCode
          }, operationDetails)
        });
        devLogger.warn({
          message,
          key: message
        });
      } else {
        const message = 'customer-data-sidebar-apollo-client: networkError';
        Raven.captureException(new Error(message), {
          extra: Object.assign({
            errorCode: err.errorCode
          }, operationDetails)
        });
        devLogger.warn({
          message,
          key: message
        });
      }
      observer.error(err);
    },
    complete() {
      observer.complete();
    }
  });
  return () => {
    if (sub) {
      sub.unsubscribe();
    }
  };
}));